import React from "react";

const getIcon = (name, color) => {
  switch (name) {
    case "Logo":
      return (
        <>
          <path
            d="M34.5949 6.32056L32.0198 18.4732L29.2819 6.32056H25.3532L26.2081 9.35364L23.6432 18.5241L20.8952 6.32056H16.9664L21.8112 23.6641H25.1903L27.7654 14.9618L30.198 23.6641H33.8417L38.5236 6.32056H34.5949Z"
            fill={color}
          />
          <path
            d="M50.7477 19.0335C50.2495 19.5278 49.6585 19.9189 49.0088 20.1844C48.3591 20.4499 47.6633 20.5845 46.9615 20.5805C44.3762 20.5805 42.6663 18.6365 42.6663 15.7561V15.6136H52.9869C53.5671 9.75102 50.5849 5.98511 45.9538 5.98511C41.6892 5.98511 38.5441 9.6187 38.5441 14.9927C38.5441 20.5907 42.0454 23.9902 46.88 23.9902C48.0417 23.9925 49.1899 23.7414 50.2446 23.2545C51.2993 22.7675 52.2351 22.0565 52.9869 21.1709L50.7477 19.0335ZM46.1167 9.04873C47.9894 9.04873 49.2515 10.5347 49.3737 12.9877H42.6052C42.819 10.6365 44.1625 9.04873 46.076 9.04873"
            fill={color}
          />
          <path
            d="M54.6867 0.0407715V21.7507L56.5799 23.6642H58.7376V0.0407715H54.6867Z"
            fill={color}
          />
          <path
            d="M60.9563 0.0407715V21.7507L62.8494 23.6642H65.0071V0.0407715H60.9563Z"
            fill={color}
          />
          <path
            d="M11.5725 0V7.75572C11.0536 7.20048 10.4267 6.75715 9.73028 6.45292C9.03421 6.14626 8.28225 5.98685 7.52163 5.98472C3.52163 5.98472 0 9.55725 0 15.2468C0 20.1425 2.80916 24 7.28754 24C8.15642 23.9778 9.01124 23.7754 9.79788 23.4058C10.5845 23.0361 11.2858 22.5072 11.8575 21.8524L13.2621 23.6743H15.6234V0H11.5725ZM8.23409 20.6718C5.89313 20.6718 4.16285 18.4733 4.16285 15.0433C4.16285 11.43 6.00508 9.35369 8.1832 9.35369C8.88422 9.38974 9.56492 9.60162 10.1626 9.9698C10.7602 10.338 11.2556 10.8506 11.603 11.4606V18.687C11.2499 19.2689 10.7586 19.7545 10.1726 20.1007C9.58668 20.447 8.92428 20.6431 8.24428 20.6718"
            fill={color}
          />
          <path
            d="M73.0781 0.010498H76.0298V5.33365H80.6303V0.010498H83.5819V12.9876H80.6303V7.44053H76.0298V12.9876H73.0781V0.010498Z"
            fill={color}
          />
          <path
            d="M89.8525 13.1707C86.6972 13.1707 85.2621 10.789 85.2621 8.16305C85.2621 5.5371 86.6972 3.17578 89.8525 3.17578C93.0077 3.17578 94.4733 5.5371 94.4733 8.16305C94.4733 10.789 93.028 13.1707 89.8525 13.1707ZM89.8525 11.4811C90.9924 11.4811 91.542 10.5549 91.542 8.16305C91.542 5.77119 90.9924 4.86535 89.8525 4.86535C88.7125 4.86535 88.2036 5.77119 88.2036 8.16305C88.2036 10.5549 88.7125 11.4811 89.8525 11.4811Z"
            fill={color}
          />
          <path
            d="M95.7766 10.4126V3.35913H98.5858V9.76117C98.5858 10.779 98.9522 11.2065 99.7868 11.2065C100.805 11.2065 101.537 10.0869 101.537 8.09196V3.35913H104.336V12.9876H101.884L101.629 10.7586H101.578C101.429 11.4531 101.043 12.0739 100.485 12.5141C99.9282 12.9544 99.2348 13.1866 98.5247 13.1708C98.1531 13.2114 97.7771 13.1678 97.4245 13.0433C97.072 12.9189 96.7519 12.7167 96.4881 12.4519C96.2242 12.187 96.0232 11.8663 95.9001 11.5133C95.7769 11.1603 95.7347 10.7841 95.7766 10.4126Z"
            fill={color}
          />
          <path
            d="M105.628 10.3003L107.46 9.75074C107.445 10.0091 107.485 10.2679 107.578 10.5093C107.672 10.7507 107.816 10.9692 108.001 11.1498C108.187 11.3305 108.409 11.469 108.653 11.556C108.897 11.643 109.156 11.6764 109.414 11.654C110.249 11.654 110.809 11.308 110.809 10.6362C110.809 9.96447 110.29 9.77108 108.529 9.15021C106.992 8.61077 105.811 7.87795 105.811 5.98482C105.811 4.31561 107.206 3.09424 109.313 3.09424C111.664 3.09424 112.631 4.29525 112.824 5.90339L110.9 6.26981C110.758 4.98736 110.157 4.58025 109.323 4.58025C108.488 4.58025 108.183 4.90594 108.183 5.50645C108.183 6.10696 108.671 6.38177 110.218 6.94157C112.01 7.61332 113.374 8.04081 113.374 10.1273C113.374 12.0001 111.959 13.0892 109.608 13.0892C107.257 13.0892 105.832 12.0103 105.628 10.3003Z"
            fill={color}
          />
          <path
            d="M119.095 13.1707C116.174 13.1707 114.291 11.3488 114.291 8.16305C114.291 5.64906 115.919 3.17578 118.881 3.17578C121.67 3.17578 123.247 5.1198 123.247 8.4684H117.232C117.303 10.3717 117.802 11.4608 119.268 11.4608C120.55 11.4608 121.029 10.5549 121.303 9.42514L123.186 10.158C122.985 11.0706 122.459 11.879 121.707 12.4332C120.954 12.9873 120.026 13.2494 119.095 13.1707ZM117.263 7.1656H120.438C120.367 5.58799 119.96 4.86535 118.891 4.86535C117.822 4.86535 117.375 5.56764 117.263 7.1656Z"
            fill={color}
          />
          <path
            d="M123.237 21.0486H73.0898V23.6745H123.237V21.0486Z"
            fill={color}
          />
        </>
      );
    case "DwellHouseLogo":
      return (
        <>
          <path
            d="M34.5949 6.32056L32.0198 18.4732L29.2819 6.32056H25.3532L26.2081 9.35364L23.6432 18.5241L20.8952 6.32056H16.9664L21.8112 23.6641H25.1903L27.7654 14.9618L30.198 23.6641H33.8417L38.5236 6.32056H34.5949Z"
            fill={color}
          />
          <path
            d="M50.7477 19.0335C50.2495 19.5278 49.6585 19.9189 49.0088 20.1844C48.3591 20.4499 47.6633 20.5845 46.9615 20.5805C44.3762 20.5805 42.6663 18.6365 42.6663 15.7561V15.6136H52.9869C53.5671 9.75102 50.5849 5.98511 45.9538 5.98511C41.6892 5.98511 38.5441 9.6187 38.5441 14.9927C38.5441 20.5907 42.0454 23.9902 46.88 23.9902C48.0417 23.9925 49.1899 23.7414 50.2446 23.2545C51.2993 22.7675 52.2351 22.0565 52.9869 21.1709L50.7477 19.0335ZM46.1167 9.04873C47.9894 9.04873 49.2515 10.5347 49.3737 12.9877H42.6052C42.819 10.6365 44.1625 9.04873 46.076 9.04873"
            fill={color}
          />
          <path
            d="M54.6867 0.0407715V21.7507L56.5799 23.6642H58.7376V0.0407715H54.6867Z"
            fill={color}
          />
          <path
            d="M60.9563 0.0407715V21.7507L62.8494 23.6642H65.0071V0.0407715H60.9563Z"
            fill={color}
          />
          <path
            d="M11.5725 0V7.75572C11.0536 7.20048 10.4267 6.75715 9.73028 6.45292C9.03421 6.14626 8.28225 5.98685 7.52163 5.98472C3.52163 5.98472 0 9.55725 0 15.2468C0 20.1425 2.80916 24 7.28754 24C8.15642 23.9778 9.01124 23.7754 9.79788 23.4058C10.5845 23.0361 11.2858 22.5072 11.8575 21.8524L13.2621 23.6743H15.6234V0H11.5725ZM8.23409 20.6718C5.89313 20.6718 4.16285 18.4733 4.16285 15.0433C4.16285 11.43 6.00508 9.35369 8.1832 9.35369C8.88422 9.38974 9.56492 9.60162 10.1626 9.9698C10.7602 10.338 11.2556 10.8506 11.603 11.4606V18.687C11.2499 19.2689 10.7586 19.7545 10.1726 20.1007C9.58668 20.447 8.92428 20.6431 8.24428 20.6718"
            fill={color}
          />
          <path
            d="M73.0781 0.010498H76.0298V5.33365H80.6303V0.010498H83.5819V12.9876H80.6303V7.44053H76.0298V12.9876H73.0781V0.010498Z"
            fill={color}
          />
          <path
            d="M89.8525 13.1707C86.6972 13.1707 85.2621 10.789 85.2621 8.16305C85.2621 5.5371 86.6972 3.17578 89.8525 3.17578C93.0077 3.17578 94.4733 5.5371 94.4733 8.16305C94.4733 10.789 93.028 13.1707 89.8525 13.1707ZM89.8525 11.4811C90.9924 11.4811 91.542 10.5549 91.542 8.16305C91.542 5.77119 90.9924 4.86535 89.8525 4.86535C88.7125 4.86535 88.2036 5.77119 88.2036 8.16305C88.2036 10.5549 88.7125 11.4811 89.8525 11.4811Z"
            fill={color}
          />
          <path
            d="M95.7766 10.4126V3.35913H98.5858V9.76117C98.5858 10.779 98.9522 11.2065 99.7868 11.2065C100.805 11.2065 101.537 10.0869 101.537 8.09196V3.35913H104.336V12.9876H101.884L101.629 10.7586H101.578C101.429 11.4531 101.043 12.0739 100.485 12.5141C99.9282 12.9544 99.2348 13.1866 98.5247 13.1708C98.1531 13.2114 97.7771 13.1678 97.4245 13.0433C97.072 12.9189 96.7519 12.7167 96.4881 12.4519C96.2242 12.187 96.0232 11.8663 95.9001 11.5133C95.7769 11.1603 95.7347 10.7841 95.7766 10.4126Z"
            fill={color}
          />
          <path
            d="M105.628 10.3003L107.46 9.75074C107.445 10.0091 107.485 10.2679 107.578 10.5093C107.672 10.7507 107.816 10.9692 108.001 11.1498C108.187 11.3305 108.409 11.469 108.653 11.556C108.897 11.643 109.156 11.6764 109.414 11.654C110.249 11.654 110.809 11.308 110.809 10.6362C110.809 9.96447 110.29 9.77108 108.529 9.15021C106.992 8.61077 105.811 7.87795 105.811 5.98482C105.811 4.31561 107.206 3.09424 109.313 3.09424C111.664 3.09424 112.631 4.29525 112.824 5.90339L110.9 6.26981C110.758 4.98736 110.157 4.58025 109.323 4.58025C108.488 4.58025 108.183 4.90594 108.183 5.50645C108.183 6.10696 108.671 6.38177 110.218 6.94157C112.01 7.61332 113.374 8.04081 113.374 10.1273C113.374 12.0001 111.959 13.0892 109.608 13.0892C107.257 13.0892 105.832 12.0103 105.628 10.3003Z"
            fill={color}
          />
          <path
            d="M119.095 13.1707C116.174 13.1707 114.291 11.3488 114.291 8.16305C114.291 5.64906 115.919 3.17578 118.881 3.17578C121.67 3.17578 123.247 5.1198 123.247 8.4684H117.232C117.303 10.3717 117.802 11.4608 119.268 11.4608C120.55 11.4608 121.029 10.5549 121.303 9.42514L123.186 10.158C122.985 11.0706 122.459 11.879 121.707 12.4332C120.954 12.9873 120.026 13.2494 119.095 13.1707ZM117.263 7.1656H120.438C120.367 5.58799 119.96 4.86535 118.891 4.86535C117.822 4.86535 117.375 5.56764 117.263 7.1656Z"
            fill={color}
          />
          <path
            d="M123.237 21.0486H73.0898V23.6745H123.237V21.0486Z"
            fill={color}
          />
        </>
      );
    case "Search":
      return (
        <>
          <circle
            cx="7.5"
            cy="7.5"
            r="6.5"
            fill="transparent"
            stroke={color}
            strokeWidth="2"
          />
          <path d="M12 12L17.8247 17.8244" stroke={color} strokeWidth="2" />
        </>
      );
    case "Caret-Right": // 0 0 9 14
      return (
        <path
          d="M1.12109 13.5361L8.24195 7.51901L1.12109 0.718597"
          stroke={color}
          fill="none"
          className="no-theme"
        />
      );
    case "Circle-Arrow-Left":
      return (
        <g fill="transparent">
          <path
            d="M8 14.5L12.5529 10L13.8765 11.2907L11.5294 13.5407H23V15.4244H11.5118L13.8588 17.6919L12.5529 19L8 14.5Z"
            fill={color}
          />

          <rect
            x="-1"
            y="1"
            width="29"
            height="28"
            rx="14"
            transform="matrix(-1 0 0 1 29 0)"
            stroke={color}
            strokeWidth="2"
            className="no-theme stroke"
          />
        </g>
      );
    case "Circle-Arrow-Right":
      return (
        <g fill="transparent" width="29" height="28">
          <path
            d="M23 14.5L18.4471 10L17.1235 11.2907L19.4706 13.5407H8V15.4244H19.4882L17.1412 17.6919L18.4471 19L23 14.5Z"
            fill={color}
          />
          <rect
            x="1"
            y="1"
            width="29"
            height="28"
            rx="14"
            stroke={color}
            strokeWidth="2"
            className="no-theme stroke"
          />
        </g>
      );
    case "Caret-Left":
      return (
        <path
          d="M8.36255 13.5361L1.2417 7.51901L8.36255 0.718597"
          stroke={color}
          fill="none"
          className="no-theme"
        />
      );
    case "Apple":
      return (
        <path
          d="M65.8,49.692c-0.027-4.875,2.179-8.555,6.642-11.265-2.5-3.573-6.27-5.539-11.251-5.925-4.716-.372-9.87,2.75-11.756,2.75-1.993,0-6.562-2.617-10.149-2.617C31.877,32.756,24,38.547,24,50.33a33.088,33.088,0,0,0,1.913,10.786c1.7,4.875,7.837,16.831,14.24,16.631,3.348-.08,5.712-2.378,10.069-2.378,4.224,0,6.416,2.378,10.149,2.378C66.827,77.655,72.379,66.789,74,61.9c-8.661-4.078-8.2-11.955-8.2-12.208h0ZM58.285,27.881a12.511,12.511,0,0,0,3.188-9.631,14.086,14.086,0,0,0-9.02,4.636,12.707,12.707,0,0,0-3.4,9.551C52.52,32.7,55.682,30.923,58.285,27.881Z"
          fill={color}
        />
      );
    case "Facebook":
      return (
        <path
          d="M43.52,80V53.164H34.531V42.5H43.52V34.1C43.52,24.969,49.1,20,57.242,20a75.461,75.461,0,0,1,8.227.422v9.539H59.82c-4.43,0-5.285,2.109-5.285,5.191V42.5h10L63.16,53.164H54.535V80"
          fill={color}
        />
      );
    case "Instagram":
      return (
        <>
          <path
            d="M8.3 1.5C10.5 1.5 10.8 1.5 11.7 1.5C12.5 1.5 12.9 1.7 13.2 1.8C13.6 2 13.9 2.1 14.2 2.4C14.5 2.7 14.7 3 14.8 3.4C14.9 3.7 15 4.1 15.1 4.9C15.1 5.8 15.1 6 15.1 8.3C15.1 10.6 15.1 10.8 15.1 11.7C15.1 12.5 14.9 12.9 14.8 13.2C14.6 13.6 14.5 13.9 14.2 14.2C13.9 14.5 13.6 14.7 13.2 14.8C12.9 14.9 12.5 15 11.7 15.1C10.8 15.1 10.6 15.1 8.3 15.1C6 15.1 5.8 15.1 4.9 15.1C4.1 15.1 3.7 14.9 3.4 14.8C3 14.6 2.7 14.5 2.4 14.2C2.1 13.9 1.9 13.6 1.8 13.2C1.7 12.9 1.6 12.5 1.5 11.7C1.5 10.8 1.5 10.6 1.5 8.3C1.5 6 1.5 5.8 1.5 4.9C1.5 4.1 1.7 3.7 1.8 3.4C2 3 2.1 2.7 2.4 2.4C2.7 2.1 3 1.9 3.4 1.8C3.7 1.7 4.1 1.6 4.9 1.5C5.8 1.5 6.1 1.5 8.3 1.5ZM8.3 0C6 0 5.8 0 4.9 0C4 0 3.4 0.200001 2.9 0.400001C2.4 0.600001 1.9 0.900001 1.4 1.4C0.900001 1.9 0.700001 2.3 0.400001 2.9C0.200001 3.4 0.1 4 0 4.9C0 5.8 0 6.1 0 8.3C0 10.6 0 10.8 0 11.7C0 12.6 0.200001 13.2 0.400001 13.7C0.600001 14.2 0.900001 14.7 1.4 15.2C1.9 15.7 2.3 15.9 2.9 16.2C3.4 16.4 4 16.5 4.9 16.6C5.8 16.6 6.1 16.6 8.3 16.6C10.5 16.6 10.8 16.6 11.7 16.6C12.6 16.6 13.2 16.4 13.7 16.2C14.2 16 14.7 15.7 15.2 15.2C15.7 14.7 15.9 14.3 16.2 13.7C16.4 13.2 16.5 12.6 16.6 11.7C16.6 10.8 16.6 10.5 16.6 8.3C16.6 6.1 16.6 5.8 16.6 4.9C16.6 4 16.4 3.4 16.2 2.9C16 2.4 15.7 1.9 15.2 1.4C14.7 0.900001 14.3 0.700001 13.7 0.400001C13.2 0.200001 12.6 0.1 11.7 0C10.8 0 10.6 0 8.3 0Z"
            fill={color}
          />
          <path
            d="M8.3 4C5.9 4 4 5.9 4 8.3C4 10.7 5.9 12.6 8.3 12.6C10.7 12.6 12.6 10.7 12.6 8.3C12.6 5.9 10.7 4 8.3 4ZM8.3 11.1C6.8 11.1 5.5 9.9 5.5 8.3C5.5 6.8 6.7 5.5 8.3 5.5C9.8 5.5 11.1 6.7 11.1 8.3C11.1 9.8 9.8 11.1 8.3 11.1Z"
            fill={color}
          />
          <path
            d="M12.7 4.9C13.2523 4.9 13.7 4.45229 13.7 3.9C13.7 3.34772 13.2523 2.9 12.7 2.9C12.1477 2.9 11.7 3.34772 11.7 3.9C11.7 4.45229 12.1477 4.9 12.7 4.9Z"
            fill={color}
          />
        </>
      );
    case "Soundcloud":
      return (
        <path
          d="M28.816,50.025l0.589,6.6-0.589,6.938a0.48,0.48,0,0,1-.447.447,0.44,0.44,0,0,1-.427-0.447l-0.569-6.938,0.569-6.6a0.436,0.436,0,0,1,.427-0.427A0.487,0.487,0,0,1,28.816,50.025Zm2.174-4.632a0.523,0.523,0,0,0-.508.508L29.974,56.628l0.508,6.938a0.523,0.523,0,0,0,.508.508,0.5,0.5,0,0,0,.477-0.508l0.589-6.938L31.467,45.9A0.5,0.5,0,0,0,30.99,45.393Zm2.59-2.448a0.562,0.562,0,0,0-.569.538L32.564,56.689l0.447,6.887a0.562,0.562,0,0,0,.569.538,0.535,0.535,0,0,0,.538-0.538l0.538-6.887L34.118,43.484a0.535,0.535,0,0,0-.538-0.538h0ZM18.231,52.758a0.273,0.273,0,0,0-.254.254L17.5,56.628l0.477,3.555a0.254,0.254,0,0,0,.508,0l0.569-3.555-0.569-3.616a0.273,0.273,0,0,0-.254-0.254h0Zm2.4-2.225a0.251,0.251,0,0,0-.254.254l-0.65,5.841,0.65,5.7a0.26,0.26,0,0,0,.254.284,0.3,0.3,0,0,0,.284-0.254l0.731-5.729-0.731-5.841A0.3,0.3,0,0,0,20.629,50.533Zm2.57-1.158a0.352,0.352,0,0,0-.335.335l-0.589,6.917,0.589,6.684a0.366,0.366,0,0,0,.335.315,0.316,0.316,0,0,0,.315-0.315l0.7-6.684-0.7-6.917a0.321,0.321,0,0,0-.315-0.335h0Zm2.57-.223a0.358,0.358,0,0,0-.366.366l-0.589,7.11L25.4,63.515a0.358,0.358,0,0,0,.366.366,0.4,0.4,0,0,0,.4-0.366l0.65-6.887-0.65-7.11a0.4,0.4,0,0,0-.4-0.366h0ZM50.289,37.887a0.794,0.794,0,0,0-.427-0.142,0.934,0.934,0,0,0-.569.193,1.041,1.041,0,0,0-.335.681V38.7L48.624,56.648l0.173,3.3,0.173,3.22a0.928,0.928,0,0,0,.9.874,0.88,0.88,0,0,0,.874-0.874l0.4-6.521-0.4-18.03a0.978,0.978,0,0,0-.457-0.731h0Zm-2.712,1.554A0.893,0.893,0,0,0,47.13,39.3a0.862,0.862,0,0,0-.447.142,0.8,0.8,0,0,0-.366.681l-0.03.173L46,56.628s0,0.03.315,6.664v0.03a0.766,0.766,0,0,0,.173.477,0.871,0.871,0,0,0,.65.315,0.824,0.824,0,0,0,.569-0.254,0.7,0.7,0,0,0,.254-0.569l0.03-.681,0.315-5.952L47.974,40.122a0.911,0.911,0,0,0-.4-0.681h0ZM36.262,41.726a0.617,0.617,0,0,0-.589.62L35.225,56.628l0.447,6.826a0.6,0.6,0,0,0,1.209,0l0.508-6.826L36.881,42.346a0.636,0.636,0,0,0-.62-0.62h0Zm38.265,6.379a8.158,8.158,0,0,0-3.108.62,14.117,14.117,0,0,0-14.048-12.84,13.852,13.852,0,0,0-5.109.955,0.89,0.89,0,0,0-.792.935V63.139a0.957,0.957,0,0,0,.874.935H74.516a7.984,7.984,0,0,0,.01-15.968h0ZM44.388,41.98a0.806,0.806,0,0,0-.792.792L43.26,56.658,43.6,63.322a0.8,0.8,0,0,0,.792.762,0.754,0.754,0,0,0,.762-0.762l0.4-6.664-0.4-13.886a0.781,0.781,0,0,0-.762-0.792h0Zm-5.445-.792a0.689,0.689,0,0,0-.65.681L37.9,56.628l0.4,6.8a0.666,0.666,0,0,0,1.331,0l0.447-6.8L39.624,41.869A0.716,0.716,0,0,0,38.943,41.188Zm2.712,0.345a0.7,0.7,0,0,0-.7.7l-0.4,14.394,0.4,6.745a0.716,0.716,0,0,0,.7.7,0.7,0.7,0,0,0,.7-0.7l0.427-6.745L42.356,42.234a0.69,0.69,0,0,0-.7-0.7h0Z"
          fill={color}
        />
      );
    case "Spotify":
      return (
        <>
          <path
            d="M65.92,68.165a2.971,2.971,0,0,1-1.666-.561c-9.717-5.855-21.022-6.1-32.187-3.815a10.055,10.055,0,0,1-1.853.4,2.424,2.424,0,0,1-2.46-2.46,2.468,2.468,0,0,1,2.118-2.616C42.624,56.3,55.658,56.548,66.776,63.2a2.633,2.633,0,0,1,1.51,2.569,2.353,2.353,0,0,1-2.367,2.4h0Z"
            fill={color}
          />
          <path
            d="M70.108,57.949a3.845,3.845,0,0,1-1.915-.654c-9.732-5.762-24.245-8.082-37.155-4.578a6.413,6.413,0,0,1-1.853.4A3.024,3.024,0,0,1,26.164,50.1a3.064,3.064,0,0,1,2.414-3.223A52.377,52.377,0,0,1,43.807,44.76c10.106,0,19.87,2.507,27.562,7.085a3.246,3.246,0,0,1,1.76,3.068A3.017,3.017,0,0,1,70.108,57.949Z"
            fill={color}
          />
          <path
            d="M74.936,46.084a3.581,3.581,0,0,1-2.009-.607c-11.087-6.618-30.91-8.206-43.742-4.625a7.4,7.4,0,0,1-2.009.4,3.594,3.594,0,0,1-3.628-3.675,3.679,3.679,0,0,1,2.71-3.722,65.264,65.264,0,0,1,18.3-2.367c11.367,0,23.28,2.367,31.985,7.443a3.656,3.656,0,0,1,2.009,3.519,3.608,3.608,0,0,1-3.613,3.628h0Z"
            fill={color}
          />
        </>
      );
    case "Twitter":
      return (
        <path
          d="M69.861,39.816c0.032,0.444.032,0.888,0.032,1.333C69.892,54.7,59.581,70.3,40.736,70.3A28.958,28.958,0,0,1,25,65.7a21.2,21.2,0,0,0,2.475.127A20.523,20.523,0,0,0,40.2,61.453a10.266,10.266,0,0,1-9.581-7.107,12.923,12.923,0,0,0,1.935.159,10.838,10.838,0,0,0,2.7-.349A10.249,10.249,0,0,1,27.03,44.1V43.972a10.32,10.32,0,0,0,4.632,1.3A10.263,10.263,0,0,1,28.49,31.567,29.128,29.128,0,0,0,49.619,42.291a11.568,11.568,0,0,1-.254-2.348A10.257,10.257,0,0,1,67.1,32.931a20.175,20.175,0,0,0,6.5-2.475A10.22,10.22,0,0,1,69.1,36.1,20.543,20.543,0,0,0,75,34.518a22.028,22.028,0,0,1-5.139,5.3h0Z"
          fill={color}
        />
      );
    case "YouTube":
      return (
        <path
          d="M76.351,36.715a6.911,6.911,0,0,0-4.863-4.894C67.2,30.664,50,30.664,50,30.664s-17.2,0-21.488,1.157a6.911,6.911,0,0,0-4.863,4.894C22.5,41.032,22.5,50.039,22.5,50.039s0,9.007,1.149,13.324a6.808,6.808,0,0,0,4.863,4.816C32.8,69.336,50,69.336,50,69.336s17.2,0,21.488-1.157a6.808,6.808,0,0,0,4.863-4.816C77.5,59.046,77.5,50.039,77.5,50.039S77.5,41.032,76.351,36.715Zm-31.976,21.5V41.861L58.75,50.039,44.375,58.217h0Z"
          fill={color}
        />
      );
    case "Github":
      return (
        <path
          d="M50,20.056a30.705,30.705,0,0,0-9.7,59.835c1.535.282,2.1-.666,2.1-1.48,0-.728-.027-2.659-.042-5.221-8.54,1.855-10.342-4.116-10.342-4.116-1.4-3.547-3.409-4.491-3.409-4.491-2.787-1.905.211-1.866.211-1.866,3.081.217,4.7,3.164,4.7,3.164,2.739,4.691,7.186,3.337,8.935,2.551A6.564,6.564,0,0,1,44.4,64.327c-6.817-.775-13.985-3.409-13.985-15.174a11.866,11.866,0,0,1,3.161-8.238,11.039,11.039,0,0,1,.3-8.126s2.577-.825,8.442,3.148a29.087,29.087,0,0,1,15.373,0c5.862-3.973,8.435-3.148,8.435-3.148a11.027,11.027,0,0,1,.3,8.126,11.844,11.844,0,0,1,3.156,8.238c0,11.8-7.178,14.39-14.018,15.15,1.1.948,2.084,2.822,2.084,5.686,0,4.1-.037,7.416-.037,8.422,0,.821.553,1.777,2.111,1.477A30.707,30.707,0,0,0,50,20.056Z"
          fill={color}
        />
      );
    case "Arrow":
      return (
        <polygon
          points="51.829 7.172 46.172 12.828 79.343 46 4 46 4 54 79.343 54 46.172 87.172 51.829 92.828 94.658 50 51.829 7.172"
          fill={color}
        />
      );
    case "Plus":
      return (
        <polygon
          points="80 46 54 46 54 20 46 20 46 46 20 46 20 54 46 54 46 80 54 80 54 54 80 54 80 46"
          fill={color}
        />
      );
    case "Minus":
      return <rect x="20" y="46" width="60" height="8" fill={color} />;
    case "Checkmark":
      return (
        <path
          fill="none"
          stroke={color}
          strokeWidth="13"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M12.1 52.1l24.4 24.4 53-53"
        />
      );
    case "Chevron Down":
      return (
        <polygon
          points="51.5 85.657 8.672 42.828 14.328 37.172 51.5 74.343 88.672 37.172 94.328 42.828 51.5 85.657"
          fill={color}
        />
      );
    case "Close":
      return (
        <path
          d="M12.5844 11L21 2.18362L18.9156 0L10.5 8.81638L2.08437 0L0 2.18362L8.41563 11L0 19.8164L2.08437 22L10.5 13.1836L18.9156 22L21 19.8164L12.5844 11Z"
          fill="#FFFFFF"
        />
      );
    case "MenuToggleClose":
      return (
        <>
          <line
            x1="6.64645"
            y1="24.6464"
            x2="25.0312"
            y2="6.26167"
            stroke={color}
          />
          <line
            x1="7.35355"
            y1="6.64645"
            x2="25.7383"
            y2="25.0312"
            stroke={color}
          />
        </>
      );
    case "MenuToggle":
      return (
        <>
          <line x1="6" y1="10.5" x2="26" y2="10.5" stroke={color} />
          <line x1="6" y1="20.5" x2="26" y2="20.5" stroke={color} />
        </>
      );
    case "CircleToggle":
      return (
        <>
          <path
            d="M24.6377 13.2263C24.6377 19.8052 19.3756 25.1272 12.8982 25.1272C6.42078 25.1272 1.15866 19.8052 1.15866 13.2263C1.15866 6.64744 6.42078 1.32544 12.8982 1.32544C19.3756 1.32544 24.6377 6.64744 24.6377 13.2263Z"
            fill="transparent"
            stroke={color}
          />
          <line
            x1="13.3982"
            y1="6.1401"
            x2="13.3982"
            y2="20.3125"
            fill="transparent"
            stroke={color}
          />
          <line
            x1="5.90417"
            y1="13.1692"
            x2="19.8922"
            y2="13.1692"
            fill="transparent"
            stroke={color}
          />
        </>
      );

    case "LongArrow": // 0 0 47 13
      return (
        <>
          <path d="M42 1L47 6.5L42 12" fill="transparent" stroke={color} />
          <line x1="4.37114e-08" y1="6.5" x2="47" y2="6.5" stroke={color} />
        </>
      );
    case "CarouselLeft": // 0 0 64 64
      return (
        <>
          <circle cx="32" cy="32" r="31.5" stroke={color} fill="transparent" />
          <path
            d="M31.5776 15.3359L15.2734 31.6402L31.5776 47.9444"
            stroke={color}
            fill="transparent"
          />
          <line
            y1="-0.5"
            x2="30.5455"
            y2="-0.5"
            transform="matrix(-1 -1.31134e-07 -1.31134e-07 1 46.5454 32.0078)"
            stroke={color}
          />
        </>
      );
    case "CarouselRight": // 0 0 64 64
      return (
        <>
          <circle cx="32" cy="32" r="31.5" stroke={color} fill="transparent" />
          <path
            d="M30.2412 15.3359L46.5454 31.6402L30.2412 47.9444"
            stroke={color}
            fill="transparent"
          />
          <line
            x1="15.2734"
            y1="31.5078"
            x2="45.8189"
            y2="31.5078"
            stroke={color}
          />
        </>
      );
    case "AccordionIcon": // 0 0 28 28
      return (
        <>
          <circle cx="14" cy="14" r="13.5" stroke={color} fill="transparent" />
          <line x1="14.5" y1="6" x2="14.5" y2="22" stroke={color} />
          <line x1="6" y1="14" x2="22" y2="14" stroke={color} />
        </>
      );
    case "AboduLogo":
      return (
        <>
          <path
            d="M27.8789 11.3544C27.8789 8.86188 29.7099 7.69238 31.3011 7.69238C32.2166 7.69238 32.9351 8.03072 33.3997 8.5236V7.83372H35.3293V14.8751H33.3997V14.0866C32.9351 14.6361 32.1883 15.0165 31.2728 15.0165C29.7801 15.0165 27.8789 13.8329 27.8789 11.3544ZM33.4563 11.3403C33.4563 10.298 32.6954 9.45272 31.6536 9.45272C30.583 9.45272 29.766 10.2556 29.766 11.3403C29.766 12.425 30.583 13.242 31.6536 13.242C32.6954 13.242 33.4562 12.3825 33.4562 11.3403H33.4563Z"
            fill={color}
          />
          <path
            d="M38.5233 14.1145V14.8749H36.5938V4.59375H38.5233V8.60819C38.9742 8.05881 39.6923 7.69221 40.636 7.69221C42.2273 7.69221 44.0441 8.86201 44.0441 11.3543C44.0441 13.8327 42.157 15.0163 40.6643 15.0163C39.7347 15.0163 38.9742 14.6638 38.5233 14.1145ZM42.157 11.3401C42.157 10.2554 41.34 9.45255 40.2699 9.45255C39.2277 9.45255 38.4672 10.2979 38.4672 11.3401C38.4672 12.3824 39.2277 13.2418 40.2699 13.2418C41.34 13.2418 42.157 12.4247 42.157 11.3401Z"
            fill={color}
          />
          <path
            d="M44.5508 11.3545C44.5483 10.8741 44.6408 10.3979 44.823 9.95341C45.0052 9.50891 45.2735 9.10484 45.6125 8.76447C45.9515 8.42409 46.3545 8.15414 46.7983 7.97015C47.242 7.78615 47.7178 7.69175 48.1982 7.69239C48.6786 7.6917 49.1545 7.78606 49.5983 7.97002C50.0421 8.15399 50.4451 8.42394 50.7842 8.76432C51.1232 9.10469 51.3916 9.50878 51.5739 9.95331C51.7561 10.3978 51.8486 10.874 51.846 11.3545C51.8486 11.8349 51.7561 12.311 51.5738 12.7556C51.3916 13.2001 51.1232 13.6042 50.7842 13.9445C50.4451 14.2849 50.0421 14.5548 49.5983 14.7388C49.1545 14.9228 48.6787 15.0171 48.1983 15.0165C47.7179 15.0171 47.2421 14.9227 46.7983 14.7387C46.3545 14.5548 45.9515 14.2848 45.6125 13.9444C45.2735 13.6041 45.0052 13.2 44.823 12.7555C44.6408 12.311 44.5483 11.8348 44.5508 11.3545ZM49.9732 11.3545C49.9732 10.3546 49.1844 9.52345 48.1983 9.52345C47.1984 9.52345 46.4379 10.3546 46.4379 11.3545C46.4379 12.3543 47.1984 13.1855 48.1983 13.1855C49.1844 13.1855 49.9732 12.3543 49.9732 11.3545Z"
            fill={color}
          />
          <path
            d="M52.4102 11.3543C52.4102 8.86171 54.2412 7.69221 55.8323 7.69221C56.7478 7.69221 57.4664 8.03055 57.931 8.52343V4.59375H59.8606V14.8749H57.931V14.0864C57.4664 14.6359 56.7196 15.0163 55.8041 15.0163C54.3115 15.0163 52.4102 13.8327 52.4102 11.3543ZM57.987 11.3401C57.987 10.2979 57.2265 9.45255 56.1843 9.45255C55.1142 9.45255 54.2973 10.2554 54.2973 11.3401C54.2973 12.4248 55.1142 13.2418 56.1843 13.2418C57.2265 13.2418 57.987 12.3824 57.987 11.3401Z"
            fill={color}
          />
          <path
            d="M60.8398 12.1292V7.83398H62.7976V11.8758C62.7976 12.8191 63.2344 13.3684 64.0934 13.3684C64.8256 13.3684 65.4315 12.8615 65.4315 11.6788V7.83398H67.3607V14.8753H65.4449V14.1007C65.2107 14.3896 64.9144 14.6219 64.578 14.7805C64.2416 14.9391 63.8738 15.0198 63.5019 15.0167C61.8396 15.0167 60.8398 13.9461 60.8398 12.1292Z"
            fill={color}
          />
          <path
            d="M0 14.8756H4.61902V3.09533L0 1.91504V14.8756Z"
            fill={color}
          />
          <path
            d="M18.6211 6.67285V14.8755H23.2402V7.85321L18.6211 6.67285Z"
            fill={color}
          />
          <path d="M4.61328 0V3.0948L18.6137 6.67246V0H4.61328Z" fill={color} />
        </>
      );
    default:
      return <path />;
  }
};

const Icon = (props) => {
  const { id = "", name, color, viewBox = "0 0 100 100", className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      aria-labelledby={`${name.replace(/\s/g, "").toLowerCase()}-${id}`}
      className={className || "icon"}
    >
      <title>{name}</title>
      {getIcon(name, color)}
    </svg>
  );
};

export default Icon;
